import React, { useRef, useState } from 'react';
import { UpTick } from '../../../Icons/upTick';
import { THEME } from '../../../cms/layout/types';
import { getTextColor } from '../../../cms/layout/util';
import { useOnClickOutside } from '../../../hooks';
import useOnHoverOutside from '../../../hooks/use-hover-outside';

export type TDropdownContentIntl = {
  activeState: boolean;
  dropdownList?: Array<{ name: string; link: string }>;
  language?: string;
  logoutFunction?: () => void;
  theme: string;
};
interface TDropdown {
  dropdownLabel: string;
  Dropdown: React.FC<TDropdownContentIntl>;
  classes: string;
  dropdownDefaultState?: boolean;
  logoutFunction?: () => void;
  hover?: boolean;
  dropdownList?: Array<{ name: string; link: string }>;
  language?: string;
  theme?: THEME;
}

const DropdownComponent = ({
  dropdownLabel,
  Dropdown,
  classes,
  logoutFunction,
  dropdownDefaultState = false,
  hover = false,
  dropdownList,
  language = 'English',
  theme = THEME.light,
}: TDropdown): JSX.Element => {
  const [dropdownState, setDropdownState] = useState(dropdownDefaultState);
  const ref = useRef(null);

  const textColor = getTextColor(theme);
  const toggleFunction = () => {
    setDropdownState(!dropdownState);
  };
  const setDropdownStateTrue = () => {
    setDropdownState(true);
  };

  useOnClickOutside(ref, () => {
    setDropdownState(false);
  });
  useOnHoverOutside(ref, () => {
    setDropdownState(false);
  });

  return (
    <div ref={ref} className={classes}>
      <button
        data-testid="dropdown-toggle-button"
        type="button"
        className={`font-medium inline-flex w-auto py-7 rounded transition duration-150 ease-in-out whitespace-nowrap items-center justify-start sm:w-full sm:justify-between ${textColor} sm:py-2`}
        id="menu-button"
        aria-expanded="true"
        aria-haspopup="true"
        onClick={toggleFunction}
        {...(hover ? { onMouseEnter: setDropdownStateTrue } : {})}
      >
        {dropdownLabel}
        <span className={`${dropdownState ? 'rotate-180' : ''}  px-2`}>
          <UpTick colorCode={theme === THEME.dark ? '#FFFFFF' : '#374151'} />
        </span>
      </button>
      <Dropdown
        activeState={dropdownState}
        logoutFunction={logoutFunction}
        dropdownList={dropdownList}
        language={language}
        theme={theme}
      />
    </div>
  );
};

export { DropdownComponent };
